// CSS Modules - component class name prefix: ProductDetailSection__

<template>
  <div :class="$style.container">
    <section>
      <h2>Anwendungen</h2>
      <ul>
        <li>Für Messstellen mit erhöhter Differenzdrucküberlast und/oder hohen Betriebsdrücken (stat. Drücken), auch in aggressiver Umgebung</li>
        <li>Für gasförmige, flüssige, verunreinigte, viskose und aggressive Messstoffe</li>
        <li>Pumpenüberwachung und -steuerung</li>
        <li>Filterüberwachung</li>
        <li>Füllstandsmessung an geschlossenen Behältern</li>
      </ul>
    </section>
    <section>
      <h2>Leistungsmerkmale</h2>
      <ul>
        <li>Differenzdruckmessbereiche ab 0 … 60 mbar</li>
        <li>Hoher Betriebsdruck (statischer Druck) und hohe Überlastsicherheit wahlweise bis 40, 100, 250 oder 400 bar</li>
        <li>Messzellenflüssigkeitsdämpfung gegen hohe Druckänderungsgeschwindigkeiten</li>
        <li>Kompatibel mit Schaltkontakten</li>
        <li>Typ 762.14: Monelausführung</li>
      </ul>
    </section>
    <section>
      <h2>Beschreibung</h2>
      <div class="columns">
        <div class="column is-half">
          <p>Diese Differenzdruckmanometer zeichnen sich durch die hochkorrosionsbeständige CrNi-Stahl-Ausführung aus. Die hohe Überlastbarkeit wird durch eine vollflächige metallische Anlage des Plattenfeder-Messelementes erreicht.</p>
          <p>Die Verwendung hochwertiger CrNi-Stahl-Werkstoffe und die robuste Bauweise zielt auf den Einsatz in chemischen und verfahrenstechnischen Prozessen und ist für flüssige und gasförmige Messstoffe, auch in aggressiver Umgebung geeignet.</p>
        </div>
        <div class="column is-half">
          <p>Die messstoffberührten Bauteile sind für diese Geräte auch aus Sonderwerkstoffen wie Monel oder Hastelloy verfügbar.</p>
          <p>Anzeigebereiche von 0 ... 60 mbar bis 0 ... 40 bar stellen die in verschiedensten Applikationen geforderten Messbereiche sicher.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ProductDetailSection"
};
</script>

<style module lang="scss">
  @import "./ProductDetailSection.scss";
</style>
